import { Stack, Typography } from '@mui/material'

import { ArtistPreSaleLotteryApplicantDetailFragment } from '@/clients/utoniq-core/schema'
import { LotteryChoicePrice } from '@/components/organisms'
import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

type TotalPaymentAmountCellProps = {
  choiceItemDetails: ArtistPreSaleLotteryApplicantDetailFragment['choiceItemDetails']
  winChoiceNumber: ArtistPreSaleLotteryApplicantDetailFragment['winChoiceNumber']
}

export const TotalPaymentAmountCell: Cell<TotalPaymentAmountCellProps> = ({
  choiceItemDetails,
  winChoiceNumber,
}) => {
  const { t } = useTranslation('consoleLotteryManagementDetail')
  return (
    <CellFrame>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        py={3}
        mt={3}
      >
        <Typography variant="h5" color="text.secondary">
          {t('totalPriceHead', 'お支払い総額')}
        </Typography>
      </Stack>
      <Stack spacing={1} sx={{ bgcolor: 'grey.50', p: 5, borderRadius: 2 }}>
        {choiceItemDetails.map((choiceItemDetail, index) => (
          <LotteryChoicePrice
            key={index}
            index={index}
            choiceLength={choiceItemDetails?.length}
            choiceItemDetail={choiceItemDetail}
            winChoiceNumber={winChoiceNumber}
          />
        ))}
      </Stack>
    </CellFrame>
  )
}
